import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { HeaderContainer } from '../global/HeaderContainer';
import NavContainer from '../global/NavContainer';
import PhoneFlip from'../PhoneFlip';
import Switcher from './Switcher';
import FooterContainer from '../global/FooterContainer';
import '../../css/global.scss';

class AppView extends Component {
  constructor() {
    super();
    this.state = {

    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    // For SSR, isMobile is always true. For client render, isMobile's value is determined by the result of the dispatch below.
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        dispatch({
          type: 'MOBILE_DETERMINE',
        });
      });

      dispatch({
        type: 'MOBILE_DETERMINE',
      });
    }
  }

  render() {
    const { isClient } = this.props;

    /*
      To prevent flashes on desktop (i.e. because the mobile layout will render first), we can apply an opacity of 0 in cases where isClient is false
      (i.e. for the SSR). The server-rendered markup is set to the client where, on componentDidMount(), we dispatch an action that updates both
      isMobile (window.innerWidth <= 991) and isClient (true). Now that isClient is true, the div wrapping the App children below will have opacity 1.
    */
    return (
      <Fragment>
      <div className="app" style={{ opacity: isClient ? 1 : 0 }}>
        <HeaderContainer />
        <NavContainer />

        <div className="content">
          <Switcher />
        </div>
      </div>
      <PhoneFlip />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ isClient, isMobile }) => ({
  isClient,
  isMobile,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

const App = connect(mapStateToProps, mapDispatchToProps)(AppView);

export default App;
